module.exports = __webpack_public_path__ + "img/singlecover.7e70aaa8.png";